import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

// Canonical staff list for Account-Manager filters. Sourced from /users so the
// filter is keyed on stable staff identity (email/id) rather than free-text name
// facets that drift. Each option's value is the staff email (stable key); the
// backend resolves it to name/email/id when matching records.
export function useAccountManagers() {
  const [managers, setManagers] = useState([]);
  useEffect(() => {
    let alive = true;
    axios
      .get(`${API}/users`, { withCredentials: true })
      .then((r) => {
        if (!alive) return;
        const list = (r.data || [])
          .filter((u) => u && (u.email || u.name))
          .map((u) => ({
            id: u.id || u._id || "",
            email: u.email || "",
            name: u.name || u.email || "Unknown",
          }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setManagers(list);
      })
      .catch(() => {
        if (alive) setManagers([]);
      });
    return () => {
      alive = false;
    };
  }, []);
  return managers;
}

// Client-side match: does a record's AM name(s) match any of the selected staff
// (compared by name, email, or id — case-insensitive)? Used by client-filtered
// lists (e.g. View Quotes). `selected` is an array of staff objects.
export function amMatchesStaff(amNameOrList, selected) {
  if (!selected || selected.length === 0) return true;
  const names = (Array.isArray(amNameOrList) ? amNameOrList : [amNameOrList])
    .map((n) => String(n || "").trim().toLowerCase())
    .filter(Boolean);
  if (names.length === 0) return false;
  return selected.some((s) => {
    const keys = [s.name, s.email, s.id]
      .map((k) => String(k || "").trim().toLowerCase())
      .filter(Boolean);
    return names.some((n) => keys.includes(n));
  });
}
